import axios from 'axios';
import { setAuthorization, logout } from '../api/account';
import { KEY } from '../../utils/constants/storageKey';

const serverBaseUrl =
  process.env.REACT_APP_SERVER_BASE_URL === 'local'
    ? 'stg'
    : process.env.REACT_APP_SERVER_BASE_URL;
console.log(
  'REACT_APP_SERVER_BASE_URL(' +
    process.env.REACT_APP_SERVER_BASE_URL +
    '), serverBaseUrl(' +
    serverBaseUrl +
    ')',
);

const client = axios.create({
  baseURL: 'https://' + serverBaseUrl + '.becon-api.com',
});

// client.defaults.baseURL = 'https://prd.becon-api.com';
// client.defaults.baseURL = 'https://stg.becon-api.com';
// client.defaults.baseURL = 'http://192.168.0.25:4000';
// client.defaults.baseURL = 'http://192.168.0.94:4000';
// client.defaults.baseURL = 'http://api.beconv2.drchoice.io';

const getWebStorage = () => {
  const localStoredAccount = localStorage.getItem(KEY);
  const sessionStoredAccount = sessionStorage.getItem(KEY);
  const sessionStoredTemporaryAuth = sessionStorage.getItem('temporary_auth');
  return {
    account: JSON.parse(localStoredAccount) || JSON.parse(sessionStoredAccount),
    accountStorageObj: localStoredAccount
      ? window.localStorage
      : window.sessionStorage,
    temporaryAuth: JSON.parse(sessionStoredTemporaryAuth),
  };
};

client.interceptors.response.use(
  (response) => {
    // 응답 후 then실행 전
    return response;
  },
  async function (error) {
    // 오류 응답을 처리
    const originalRequest = error.config;
    // Access Token 만료 처리
    // 401 인증에러 났을 경우 ---- 5분 기간 -- 최초1번 refresh
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const { account, accountStorageObj, temporaryAuth } = getWebStorage();

      //참고
      if (account) {
        const response = await client.post('/account/auth/refresh', {
          refresh_token: account.refresh_token,
        });
        // refresh_token 서버에게 주면 새로운 토큰 발급해준다.
        const new_access_token = response.data.access_token;
        account.access_token = new_access_token;
        accountStorageObj.setItem(KEY, JSON.stringify(account));

        originalRequest.headers['Authorization'] = 'Bearer ' + new_access_token;
        setAuthorization(new_access_token);
      } else if (temporaryAuth) {
        const response = await client.post(
          '/shampoo/temporary-auth/accesstoken',
          {
            auth_key: temporaryAuth.auth_key,
            auth_secret: temporaryAuth.auth_secret,
          },
        );
        const new_access_token = response.data.access_token;

        originalRequest.headers['Authorization'] = 'Bearer ' + new_access_token;
        setAuthorization(new_access_token);
      }

      return client(originalRequest);
    }

    // 탈퇴 회원 로그아웃 처리
    if (
      error.response.status === 400 &&
      error.response.data.code === 'UNAUTHORIZED'
    ) {
      logout();
    }

    // Refresh Token 실패 처리
    if (
      error.response.status === 400 &&
      originalRequest.url === '/account/auth/refresh'
    ) {
      logout();
    }

    return Promise.reject(error);
  },
);

export default client;
